import React, { useEffect } from 'react';
import { Theme, Snackbar, makeStyles, Slide, IconButton } from '@material-ui/core';
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { PasslyAlert } from '..';
import { ISnackbarState } from '@app/models';
import { handleResetSnackbar } from '@app/store/actions/snackbar.actions';
import { TransitionProps } from '@material-ui/core/transitions';
import { Clear } from '@material-ui/icons';

export const PasslySnackbarStyles = makeStyles((theme: Theme) => {
    return {
        root: {
            position: 'absolute',
            width: '100%',
            height: 50,
            top: 0,
            alignItems: 'start'
        }
    };
});

export function PasslySnackbar() {
    const classes = PasslySnackbarStyles();
    const dispatch = useDispatch();

    const snackbarData: ISnackbarState = useSelector((state: any) => state.snackbar.snackbar);

    const [showSnackbar, setShowSnackbar] = useState(false);

    useEffect(() => {
        if (snackbarData.show) {
            setShowSnackbar(true);
        }
    }, [snackbarData]);

    const handleHideSnackbar = () => {
        dispatch(handleResetSnackbar());
        setShowSnackbar(false);
    };

    const transitionDown = (props: TransitionProps) => {
        return <Slide {...props} direction='down' />;
    };

    return (
        <Snackbar
            classes={{ root: classes.root }}
            open={showSnackbar}
            autoHideDuration={snackbarData.dismissOnly ? null : 6000}
            onClose={handleHideSnackbar}
            TransitionComponent={transitionDown}
        >
            <PasslyAlert
                severity={snackbarData.severity}
                elevation={6}
                variant={snackbarData.severity === 'info' ? 'outlined' : 'filled'}
                action={
                    <IconButton size='small' color='inherit' onClick={handleHideSnackbar}>
                        <Clear fontSize='small' />
                    </IconButton>
                }
            >
                {snackbarData.message}
            </PasslyAlert>
        </Snackbar>
    );
}
